// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federabmessungen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federabmessungenDE: PageEntry = {
  id: "post.federabmessungen",
  locale: "de",
  slug: "federabmessungen",
  seo: {
    title: "Glossar: Federabmessungen einfach erklärt | Dietz GmbH",
    description: "Die Federabmessungen beziehen sich auf die geometrischen Maße einer Feder, die ihre Größe und Form bestimmen. Diese Abmessungen umfassen Parameter wie Drahtdurchmesser, Windungszah",
  },
  type: "post",
  h1: "Glossar: Federabmessungen einfach erklärt",
  intro: "Die Federabmessungen beziehen sich auf die geometrischen Maße einer Feder, die ihre Größe und Form bestimmen. Diese Abmessungen umfassen Parameter wie Drahtdurchmesser, Windungszahl, Außendurchmesser und freie Länge. Die genaue Festlegung der Federabmessungen ist entscheidend für die Funktionalität und Leistung der Feder in einer bestimmten Anwendung. Ingenieure und Konstrukteure berücksichtigen dabei die physikalischen Anforderungen und Belastungen, um optimale Abmessungen für eine effiziente Federkonstruktion zu gewährleisten.",
  blocks: [

  ],
};
